var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multi-selector',{attrs:{"filterable":true,"options":_vm.batchNoList,"remote":_vm.searchBatchList},model:{value:(_vm.batchs),callback:function ($$v) {_vm.batchs=$$v},expression:"batchs"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cc8657b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bussiness-select/BatchSelector.vue
// module id = null
// module chunks = 